import React , { useCallback, useState } from 'react'
import DataGrid, { Column, Button, Selection, LoadPanel } from 'devextreme-react/data-grid'
import Popup from 'devextreme-react/popup'
import { Toolbar, Item } from 'devextreme-react/toolbar'
import client from 'api'

import fileDownload from 'js-file-download'
import printJS from 'print-js'

export const BackgroundJobsFiles = ({ selectedRowFiles }: any) => {

    const [blobUrls, setBlobUrls] = useState<any>(null)
    const [isPopupVisible, setIsPopupVisible] = useState(false)
    const [popupSize, setPopupSize] = useState({ width: 80, height: 80})
    const [fullScreen, setFullScreen] = useState(false)

    const fileActions = useCallback( async(e: any, actionType='') => {
        const fileName = e.row?.data.fileName || e.data.fileName
        const res = await client.get(`api/ixweb/get_file/?filename=${fileName}`, {responseType: 'blob'})
        const blob: any = new Blob([res.data], {type: "application/pdf"})
        const pdfUrl = URL.createObjectURL(blob)

        if(actionType === 'download') { fileDownload(res.data, fileName) }

        if(actionType === 'print') { printJS(pdfUrl) }

        if(actionType === 'open') {
            setBlobUrls(pdfUrl)
            setIsPopupVisible(true)
        }

    },[])

    const TitleRender = () => {
        return(
            <Toolbar>
                <Item widget='dxButton' location='after' options={{type: 'default', icon: fullScreen ? 'collapse' : 'expand', onClick: () => {setFullScreen(!fullScreen)}}} />
                <Item widget='dxButton' location='after' options={{type: 'default', icon: 'close', onClick: () => { 
                    setIsPopupVisible(false)
                    setFullScreen(false)
                    }}} />
            </Toolbar>
        )
    }

    const onResizePopup = useCallback((e: any) => {
        const calculatePopupSize = (popupSize: number | string, windowSize: number) => {
            return typeof popupSize === 'string' ? Number((`${popupSize}` as any).match(/(\d+)/)[0]) : (popupSize/windowSize) * 100
        }

        setPopupSize({ width: calculatePopupSize(e.width, window.innerWidth), height: calculatePopupSize(e.height, window.innerHeight)})

    }, [])

    return (
        <div style={{padding: '0 15px 0 15px'}}>
            <DataGrid
                dataSource={selectedRowFiles?.map((file: any, index: any) => ({fileName: file, HDR_ID: index}))}
                onRowDblClick={(e) => fileActions(e, 'open')}
                showBorders={true}
                showColumnLines={true}
            >
                <Selection mode='single' deferred={false}/>
                <LoadPanel enabled={false}/>
                
                <Column dataField='fileName' />
                <Column type="buttons" dataField='actions'>
                    <Button text='download' icon='download' onClick={(e) => fileActions(e, 'download')}/>
                    <Button text='print' icon='print' onClick={(e) => fileActions(e, 'print')}/>
                    <Button text='open' icon='file' onClick={(e) => fileActions(e, 'open')} />
                </Column>
            </DataGrid>
            <Popup
                visible={isPopupVisible}
                showTitle={true}
                dragEnabled={!fullScreen}
                hideOnOutsideClick={true}
                deferRendering={false}
                resizeEnabled={!fullScreen}
                onHidden={() => setIsPopupVisible(false)}
                height={`${popupSize.height}vh`}
                width={`${popupSize.width}vw`}
                fullScreen={fullScreen}
                titleRender={TitleRender}
                {...!fullScreen && {onResize: onResizePopup}}
                contentRender={() => (<div style={{textAlign: 'center', height:'100%'}}><iframe title='PDF' src={blobUrls} style={{width:'100%', height:'100%'}}></iframe></div>)}
            >
            </Popup>
        </div>
    )
}
